import {
    app,
    Component,
    ojs,
    v,
} from "modular-openscriptjs";
import { empty, eParse } from "../../../helpers";
import { beginSuggestionRequest, isSuggestionRequestCurrent } from "../../../helpers";
import { dc } from "../../../declarations";
import CategoryProductsDefault from "./CategoryProductsDefault";
import CategoryProductsResult from "./CategoryProductsResult";
import AlgoliaSearch from "../../../classes/AlgoliaSearch";

const h = app("h");

ojs(
    CategoryProductsDefault,
    CategoryProductsResult,
);

export default class CategoryProductsPage extends Component {

    $$app = {
        has: {
            searchCharacter: async (ed, event) => {
                const { message } = eParse(ed);
                let query = message.get("value");

                if (empty(query)) {
                    dc.searchSuggestions.value = [];
                    return;
                }

                /**
                 * @type {AlgoliaSearch}
                 */
                let client = app("AlgoliaSearch");

                const ticket = beginSuggestionRequest();
                let result = await client.getSuggestions(query);
                // The user may have navigated away while this was in flight.
                if (!isSuggestionRequestCurrent(ticket)) {
                    return;
                }

                dc.searchSuggestions.value = result;
            },
        },
    };

    render(...args) {
        return h.div(
            v(dc.searchQuery, (searchState) =>
                empty(searchState.value)
                    ? h.CategoryProductsDefault()
                    : h.CategoryProductsResult()
            ),
            ...args,
        );
    }
}

ojs(CategoryProductsPage);
